/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * MDLink
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {AddPreviewToken200} from './schemas/add-preview-token200';

import type {BatchSignS3PartUrls200} from './schemas/batch-sign-s3-part-urls200';

import type {BulkDeleteFileEntriesBody} from './schemas/bulk-delete-file-entries-body';

import type {CompleteS3MultipartUpload200} from './schemas/complete-s3-multipart-upload200';

import type {CreateS3MultipartUploadBody} from './schemas/create-s3-multipart-upload-body';

import type {CreateS3MultipartUpload200} from './schemas/create-s3-multipart-upload200';

import type {GetS3UploadedParts200} from './schemas/get-s3-uploaded-parts200';

import type {ListFileEntriesParams} from './schemas/list-file-entries-params';

import type {ListFileEntries200} from './schemas/list-file-entries200';

import type {PresignS3PostUrlBody} from './schemas/presign-s3-post-url-body';

import type {PresignS3PostUrl200} from './schemas/presign-s3-post-url200';

import type {RestoreDeletedEntriesRestoreBody} from './schemas/restore-deleted-entries-restore-body';

import type {RetrieveFileEntryModel200} from './schemas/retrieve-file-entry-model200';

import type {S3FileEntryStoreBody} from './schemas/s3-file-entry-store-body';

import type {S3FileEntryStore200} from './schemas/s3-file-entry-store200';

import type {SimpleFileUploadBody} from './schemas/simple-file-upload-body';

import type {SimpleFileUpload200} from './schemas/simple-file-upload200';

import type {StoreTusFileEntryBody} from './schemas/store-tus-file-entry-body';

import type {StoreTusFileEntry200} from './schemas/store-tus-file-entry200';

import type {UpdateFileEntryBody} from './schemas/update-file-entry-body';

import type {UpdateFileEntry200} from './schemas/update-file-entry200';

import type {UploadCorsBody} from './schemas/upload-cors-body';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Retrieve file entry model
 */
export const retrieveFileEntryModel = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveFileEntryModel200>>,
) => {
  return orvalApiFetch<RetrieveFileEntryModel200>(
    {url: `/file-entries/${id}/model`, method: 'GET'},
    options,
  );
};
/**
 * @summary Retrieve file entry content
 */
export const retrieveFileEntryContent = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<unknown>>,
) => {
  return orvalApiFetch<unknown>(
    {url: `/file-entries/${id}`, method: 'GET'},
    options,
  );
};
/**
 * @summary List all file entries
 */
export const listFileEntries = (
  params?: ListFileEntriesParams,
  options?: SecondParameter<typeof orvalApiFetch<ListFileEntries200>>,
) => {
  return orvalApiFetch<ListFileEntries200>(
    {url: `/file-entries`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Upload a file
 */
export const simpleFileUpload = (
  simpleFileUploadBody: SimpleFileUploadBody,
  options?: SecondParameter<typeof orvalApiFetch<SimpleFileUpload200>>,
) => {
  const formData = new FormData();
  formData.append(`file`, simpleFileUploadBody.file);
  if (
    simpleFileUploadBody.parentId !== undefined &&
    simpleFileUploadBody.parentId !== null
  ) {
    formData.append(`parentId`, simpleFileUploadBody.parentId.toString());
  }
  if (
    simpleFileUploadBody.relativePath !== undefined &&
    simpleFileUploadBody.relativePath !== null
  ) {
    formData.append(`relativePath`, simpleFileUploadBody.relativePath);
  }

  return orvalApiFetch<SimpleFileUpload200>(
    {
      url: `/file-entries`,
      method: 'POST',
      headers: {'Content-Type': 'multipart/form-data'},
      data: formData,
    },
    options,
  );
};
/**
 * @summary Update file entry
 */
export const updateFileEntry = (
  entryId: number,
  updateFileEntryBody?: UpdateFileEntryBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateFileEntry200>>,
) => {
  return orvalApiFetch<UpdateFileEntry200>(
    {
      url: `/file-entries/${entryId}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: updateFileEntryBody,
    },
    options,
  );
};
/**
 * @summary Bulk delete file entries
 */
export const bulkDeleteFileEntries = (
  bulkDeleteFileEntriesBody?: BulkDeleteFileEntriesBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/file-entries/bulk-delete`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: bulkDeleteFileEntriesBody,
    },
    options,
  );
};
/**
 * @summary Download files
 */
export const downloadFiles = (
  hashes: string,
  options?: SecondParameter<typeof orvalApiFetch<string>>,
) => {
  return orvalApiFetch<string>(
    {url: `/file-entries/download/${hashes}`, method: 'GET'},
    options,
  );
};
export const restoreDeletedEntriesRestore = (
  restoreDeletedEntriesRestoreBody: RestoreDeletedEntriesRestoreBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/file-entries/restore`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: restoreDeletedEntriesRestoreBody,
    },
    options,
  );
};
/**
 * @summary Add preview token to file entry
 */
export const addPreviewToken = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<AddPreviewToken200>>,
) => {
  return orvalApiFetch<AddPreviewToken200>(
    {url: `/file-entries/${id}/add-preview-token`, method: 'POST'},
    options,
  );
};
/**
 * @summary Create s3 multipart upload
 */
export const createS3MultipartUpload = (
  createS3MultipartUploadBody: CreateS3MultipartUploadBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateS3MultipartUpload200>>,
) => {
  return orvalApiFetch<CreateS3MultipartUpload200>(
    {
      url: `/s3/multipart/create`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: createS3MultipartUploadBody,
    },
    options,
  );
};
/**
 * @summary Batch sign s3 part urls
 */
export const batchSignS3PartUrls = (
  options?: SecondParameter<typeof orvalApiFetch<BatchSignS3PartUrls200>>,
) => {
  return orvalApiFetch<BatchSignS3PartUrls200>(
    {url: `/s3/multipart/batch-sign-part-urls`, method: 'POST'},
    options,
  );
};
/**
 * @summary Get s3 uploaded parts
 */
export const getS3UploadedParts = (
  options?: SecondParameter<typeof orvalApiFetch<GetS3UploadedParts200>>,
) => {
  return orvalApiFetch<GetS3UploadedParts200>(
    {url: `/s3/multipart/get-uploaded-parts`, method: 'POST'},
    options,
  );
};
/**
 * @summary Complete s3 multipart upload
 */
export const completeS3MultipartUpload = (
  options?: SecondParameter<typeof orvalApiFetch<CompleteS3MultipartUpload200>>,
) => {
  return orvalApiFetch<CompleteS3MultipartUpload200>(
    {url: `/s3/multipart/complete`, method: 'POST'},
    options,
  );
};
/**
 * @summary Abort s3 multipart upload
 */
export const abortS3MultipartUpload = (
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/s3/multipart/abort`, method: 'POST'},
    options,
  );
};
/**
 * @summary Presign s3 post url
 */
export const presignS3PostUrl = (
  presignS3PostUrlBody: PresignS3PostUrlBody,
  options?: SecondParameter<typeof orvalApiFetch<PresignS3PostUrl200>>,
) => {
  return orvalApiFetch<PresignS3PostUrl200>(
    {
      url: `/s3/simple/presign`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: presignS3PostUrlBody,
    },
    options,
  );
};
export const s3FileEntryStore = (
  s3FileEntryStoreBody: S3FileEntryStoreBody,
  options?: SecondParameter<typeof orvalApiFetch<S3FileEntryStore200>>,
) => {
  return orvalApiFetch<S3FileEntryStore200>(
    {
      url: `/s3/entries`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: s3FileEntryStoreBody,
    },
    options,
  );
};
/**
 * @summary Upload CORS configuration for S3
 */
export const uploadCors = (
  uploadCorsBody: UploadCorsBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/s3/cors/upload`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: uploadCorsBody,
    },
    options,
  );
};
/**
 * @summary Store tus file entry
 */
export const storeTusFileEntry = (
  storeTusFileEntryBody: StoreTusFileEntryBody,
  options?: SecondParameter<typeof orvalApiFetch<StoreTusFileEntry200>>,
) => {
  return orvalApiFetch<StoreTusFileEntry200>(
    {
      url: `/tus/entries`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: storeTusFileEntryBody,
    },
    options,
  );
};
export const tusTusServer = (
  any: string,
  options?: SecondParameter<typeof orvalApiFetch<string>>,
) => {
  return orvalApiFetch<string>(
    {url: `/tus/upload/${any}`, method: 'GET'},
    options,
  );
};
export type RetrieveFileEntryModelResult = NonNullable<
  Awaited<ReturnType<typeof retrieveFileEntryModel>>
>;
export type RetrieveFileEntryContentResult = NonNullable<
  Awaited<ReturnType<typeof retrieveFileEntryContent>>
>;
export type ListFileEntriesResult = NonNullable<
  Awaited<ReturnType<typeof listFileEntries>>
>;
export type SimpleFileUploadResult = NonNullable<
  Awaited<ReturnType<typeof simpleFileUpload>>
>;
export type UpdateFileEntryResult = NonNullable<
  Awaited<ReturnType<typeof updateFileEntry>>
>;
export type BulkDeleteFileEntriesResult = NonNullable<
  Awaited<ReturnType<typeof bulkDeleteFileEntries>>
>;
export type DownloadFilesResult = NonNullable<
  Awaited<ReturnType<typeof downloadFiles>>
>;
export type RestoreDeletedEntriesRestoreResult = NonNullable<
  Awaited<ReturnType<typeof restoreDeletedEntriesRestore>>
>;
export type AddPreviewTokenResult = NonNullable<
  Awaited<ReturnType<typeof addPreviewToken>>
>;
export type CreateS3MultipartUploadResult = NonNullable<
  Awaited<ReturnType<typeof createS3MultipartUpload>>
>;
export type BatchSignS3PartUrlsResult = NonNullable<
  Awaited<ReturnType<typeof batchSignS3PartUrls>>
>;
export type GetS3UploadedPartsResult = NonNullable<
  Awaited<ReturnType<typeof getS3UploadedParts>>
>;
export type CompleteS3MultipartUploadResult = NonNullable<
  Awaited<ReturnType<typeof completeS3MultipartUpload>>
>;
export type AbortS3MultipartUploadResult = NonNullable<
  Awaited<ReturnType<typeof abortS3MultipartUpload>>
>;
export type PresignS3PostUrlResult = NonNullable<
  Awaited<ReturnType<typeof presignS3PostUrl>>
>;
export type S3FileEntryStoreResult = NonNullable<
  Awaited<ReturnType<typeof s3FileEntryStore>>
>;
export type UploadCorsResult = NonNullable<
  Awaited<ReturnType<typeof uploadCors>>
>;
export type StoreTusFileEntryResult = NonNullable<
  Awaited<ReturnType<typeof storeTusFileEntry>>
>;
export type TusTusServerResult = NonNullable<
  Awaited<ReturnType<typeof tusTusServer>>
>;
